/** Material UI Packages. */
import { Box, CircularProgress, styled } from '@mui/material';

const DisabledBackground = styled(Box)({
    width: '100%',
    height: '100%',
    position: 'fixed',
    left: 0,
    top: 0,
    background: '#ccc',
    opacity: 0.5,
    zIndex: 2101,
});

export const CircularLoading = ({ loading }) => {
    return (
        <>
            {loading ? (
                <>
                    <CircularProgress
                        size={70}
                        sx={{
                            position: 'fixed',
                            left: '48%',
                            top: '47%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 2102,
                        }}
                    />
                    <DisabledBackground />
                </>
            ) : null}
        </>
    );
};

export default CircularLoading;
